import { useSelectedFeature } from 'map-feature-info'
import { layerStyles } from 'map-style'

export default function useLineStyle() {
  const selectedFeature = useSelectedFeature()
  const lineLayerStyle = layerStyles.getLineLayerStyle(selectedFeature?.id)
  return lineLayerStyle
}
